import { Button, ButtonProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

import { BaseFeedbackSnackbarContent } from "@app/analytics/components/reports/ReportFeedbackSnackbar";

export const ContentWrapper = styled(BaseFeedbackSnackbarContent)({
  width: "400px",
});

export const FeedbackButton = styled((props: ButtonProps) => (
  <Button variant="outlined" {...props} />
))(({ theme }) => ({
  height: "44px",
  borderColor: theme.palette.shades.neutral[100],
  color: theme.palette.shades.neutral[500],
  fontSize: "1rem",
  "& svg": {
    color: theme.palette.shades.neutral[300],
    height: "16px",
    width: "16px",
  },
}));
